/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IDiyPage {
  pageHeading?: string;
  pageImage?: string;
  pageText?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class DiyActivity extends Component {
  private readonly diyPage: IDiyPage = {
    pageHeading: 'no-sew doll carrier',
    pageImage:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDvdA',
    pageText:
      'They carry and cuddle their favorite doll from room to room, on car trips and wherever they go. Plan this fun DIY activity to show your little one that you notice how good they care for their baby doll. A soft doll carrier is easy to make and lets kids be hands-free while keeping their doll close to heart.',
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <h1 className='page-heading'>{this.diyPage.pageHeading}</h1>
          </div>
          <div className='col-lg-12 col-md-12'>
            <div className='diy-page-image'>
              <img
                className='img-responsive'
                src={this.diyPage.pageImage}
                alt={this.diyPage.pageHeading}
              />
            </div>
          </div>
          <div className='col-lg-12 col-md-12'>
            <div className='diy-page-text'>
              <p>{this.diyPage.pageText}</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DiyActivity;
